
























































import {
  Vue, Prop, Component, Emit,
} from 'vue-property-decorator';
import { VbLoadingService, VbSnackbarService, VbTooltipSlot } from 'bag-of-holding-library';
import JSZip from 'jszip';
import ActivityFile from '@/domain/schedule/activitie/activity-file.entity';
import LabelSlot from '@/shared/slots/label-slot.component.vue';
import ActivityService from '@/domain/schedule/activitie/activity.service';
import FilePickerButton from '@/shared/buttons/file-picker-button.component.vue'
import ActivityDetailed from '@/domain/schedule/activitie/activity-detailed.entity';
import Loading from '@/shared/loading/loading.component.vue';

@Component({
  components: {
    LabelSlot,
    VbTooltipSlot,
    FilePickerButton,
    Loading,
  },
})
export default class ManageActivityFileList extends Vue {
  @Prop({
    required: true,
  })
  files!: ActivityFile[];

  @Prop({
    required: true,
  })
  activity!: ActivityDetailed;

  @Prop({
    type: Boolean,
    default: false,
  })
  isUploadFiles!: boolean;

  disableDelete: boolean = false;

  filePickerKey = 0;

  isUploading: boolean = false;

  haveFiles() {
    return this.files.length !== 0;
  }

  deleteFile(fileId: string) {
    VbLoadingService.show()
    this.disableDelete = true;
    ActivityService.deleteFile(this.activity.id, fileId)
      .then((response: any) => {
        this.$emit('deleteFile', fileId)
        VbSnackbarService.showSuccess('Arquivo deletado com sucesso')
      })
      .catch((err: any) => VbSnackbarService.handleHttpError(err))
      .finally(() => {
        VbLoadingService.hide();
        this.disableDelete = false;
      })
  }

  getFile(file: ActivityFile) {
    VbLoadingService.show();
    file.loadingDownload = true;
    ActivityService.getFile(this.activity.id, file.id)
      .then((response: any) => {
        const { data } = response;
        const blob = new Blob([data], { type: '*/*' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.target = '_blank';
        link.download = file.originalName;
        link.click();
      })
      .catch((e) => {
        if (file.url) {
          window.open(file.url, '_blank');
          return;
        }
        VbSnackbarService.handleHttpError(e)
      })
      .finally(() => {
        VbLoadingService.hide();
        file.loadingDownload = false;
      })
  }

  get filePickerTooltip(): string {
    return this.disableUploadButton
      ? 'Favor preencher campo Resultado e Nível de talento'
      : 'Fazer upload de arquivo'
  }

  zipFile(file: any): Promise<File> {
    const zip = new JSZip();
    zip.file(file.name, file);
    const nameWithoutExtension = file.name.replace(/\.[^/.]+$/, '');
    return zip.generateAsync({ type: 'blob' }).then((blob: Blob) => new File(
      [blob],
      `${nameWithoutExtension}.zip`,
      { type: 'application/zip' },
    ));
  }

  onFileSelected(file: any) {
    VbLoadingService.show()
    this.isUploading = true;
    const upload = this.activity.name === 'ADM' ? this.zipFile(file) : Promise.resolve(file);
    upload
      .then((fileToUpload: File) => ActivityService.saveFile(this.activity.id, fileToUpload))
      .then((response: ActivityFile) => {
        this.activity.files.push(response)
        const message = 'Arquivo salvo com sucesso';
        VbSnackbarService.showSuccess(message)
        this.filePickerKey += 1;
      })
      .catch((err: any) => VbSnackbarService.handleHttpError(err))
      .finally(() => {
        VbLoadingService.hide();
        this.isUploading = false;
      })
  }

  get showUploadButton(): boolean {
    return this.isUploadFiles
      && (this.activity.name === 'ADM'
        || this.activity.name === 'Tempo de Casa')
      && !this.activity.isApproved();
  }

  get disableUploadButton(): boolean {
    return !this.activity.hasResult() && this.activity.name === 'ADM';
  }
}
